import { Component, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Config } from "../../config.const";

// esempio di parametro: http://localhost:4200/reset?p=$2a$04$jrZx0HJHU94nIVx910Ke.eWsbAUOIKVW%2FMOAGqF3DDsfIC12Ok4ie

@Component({
    selector: 'app-reset-form',
    templateUrl: './reset-form.html'
})
export class ResetFormComponent {

    @ViewChild('loading')
    loading: TemplateRef<any>;

    showErrorBox: boolean = false
    showInfoBox: boolean = false
    codice_fiscale: string
    message: string

    securityParam: string

    changing: Subscription;
    formGroup = new FormGroup({
        codice_fiscale: new FormControl(),
        nuova: new FormControl(),
        nuova2: new FormControl(),
        security_param: new FormControl()
    });

    constructor(
        private modalService: NgbModal,
        route: ActivatedRoute,
        private router: Router
    ) {
        this.securityParam = route.snapshot.queryParams['p']
        if (!this.securityParam) {
            console.error("Missing security param (p)")
            return
        }
    }

    async confirm() {

        this.formGroup.get('security_param').setValue(this.securityParam)

        this.showErrorBox = false
        this.showInfoBox = false

        const modalRef = this.modalService.open(
            this.loading,
            { backdrop: 'static' }
        );

        try {
            const request = await fetch(`${Config.baseURL}/reset-password`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.formGroup.getRawValue())
            });
            const response = await request.json()

            debugger
            if (response.success) {
                this.showInfoBox = true
                this.router.navigate(['/'])
            } else {
                this.showErrorBox = true
            }
            this.message = response.message

        } catch (err) {
        } finally {
            modalRef.close();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/opzioni/reset-form/reset-form.ts